import { render, staticRenderFns } from "./WorkgroupComments.vue?vue&type=template&id=78256085"
import script from "./WorkgroupComments.vue?vue&type=script&lang=js"
export * from "./WorkgroupComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports